export default __webpack_public_path__ + "static/media/img_shouye_chanpin_03.3fdb9b02.jpg";